<template>
  <ClientOnly>
    <button
      v-if="['index', 's-url', 'ch-id'].includes(route.name as string)"
      @click="onOpenBusket"
      :class="['index', 's-url', 'ch-id'].includes(route.name as string) ? '' : 'md:hidden'"
      class="h-full px-6 max-md:px-2 items-center justify-center flex"
    >
      <ICart :class="basket.length > 0 ? 'fill-primary' : 'opacity-45'" />
    </button>
  </ClientOnly>

  <ClientOnly>
    <Teleport to="body">
      <button
        v-if="basket.length > 0 && !basketDialogVisible"
        @click="onOpenBusket"
        :class="[
          ['index', 's-url', 'ch-id', 'catalog'].includes(route.name as string) ? '' : 'md:hidden',
          ['order', 'dialogs'].includes(route.name as string) ? 'max-md:hidden' : '',
          { '!bottom-[5.5rem]': !isDesktop && route.name === 'index' && isAuth },
          { '!bottom-[190px]': !isDesktop && route.name === 'orders' && lengthActiveOrders > 0 },
          { 'max-md:!bottom-[calc(74px_+_env(safe-area-inset-bottom))]': !isDesktop && isAuth && !['index', 'order', 'dialogs'].includes(route.name as string) },
        ]"
        class="fixed bottom-4 right-4 z-[1001] p-4 rounded-2xl bg-primary text-white items-center gap-2.5 flex"
      >
        <span class="font-bold text-white">
          {{
            basket
              .reduce((acc, place) => acc + (place.format?.price || 0) * (place.quantity || 1), 0)
              .toLocaleString()
          }}
          ₽
        </span>
        <ICart class="text-white" />
      </button>
    </Teleport>
  </ClientOnly>

  <ClientOnly>
    <Teleport to="body">
      <ElDialog
      v-model="basketDialogVisible"
      class="wrapper-dialog !rounded-3xl flex justify-center md:max-w-[496px] max-md:!w-[calc(100%-32px)] !my-10"
      :show-close="false"
    >
      <div class="flex flex-col rounded-3xl p-4 bg-bgnew">
        <div class="flex items-center justify-between">
          <h2 class="text-2xl font-bold">Корзина</h2>
          <div class="flex items-center gap-3.5">
            <button
              v-if="basket.length > 0"
              @click="draftId !== 0 ? (dialogDeleteLastPlace = true) : clearBasket()"
              class="text-txsecondary text-sm"
            >
              Очистить
            </button>
            <button @click="basketDialogVisible = false" class="text-txsecondary text-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M17.7208 6.27916C17.542 6.10042 17.2996 6 17.0467 6C16.7939 6 16.5514 6.10042 16.3726 6.27916L12 10.6518L7.62737 6.27916C7.44857 6.10042 7.2061 6 6.95327 6C6.70044 6 6.45797 6.10042 6.27916 6.27916C6.10042 6.45797 6 6.70044 6 6.95327C6 7.2061 6.10042 7.44857 6.27916 7.62737L10.6518 12L6.27916 16.3726C6.10042 16.5514 6 16.7939 6 17.0467C6 17.2996 6.10042 17.542 6.27916 17.7208C6.45797 17.8996 6.70044 18 6.95327 18C7.2061 18 7.44857 17.8996 7.62737 17.7208L12 13.3482L16.3726 17.7208C16.5514 17.8996 16.7939 18 17.0467 18C17.2996 18 17.542 17.8996 17.7208 17.7208C17.8996 17.542 18 17.2996 18 17.0467C18 16.7939 17.8996 16.5514 17.7208 16.3726L13.3482 12L17.7208 7.62737C17.8996 7.44857 18 7.2061 18 6.95327C18 6.70044 17.8996 6.45797 17.7208 6.27916Z"
                  fill="#1B1C1E"
                  fill-opacity="0.4"
                />
              </svg>
            </button>
          </div>
        </div>
        <template v-if="basket.length > 0">
          <el-scrollbar class="mt-4" max-height="calc(100dvh - 290px)">
            <div class="space-y-5">
              <div
                v-for="group in groupedBasket"
                :key="group.id"
                class="p-4 bg-bgmain rounded-[20px]"
              >
                <div class="flex items-center justify-between gap-3 mb-4">
                  <div class="flex items-center gap-3 flex-1 min-w-0">
                    <div
                      v-if="!group.avatar"
                      class="w-8 h-8 rounded-full bg-bgnew flex-shrink-0"
                    ></div>
                    <img
                      v-else
                      :src="group.avatar"
                      alt="place"
                      class="w-8 h-8 rounded-full flex-shrink-0"
                    />
                    <p class="text-primary text-base line-clamp-1 flex-1">
                      {{ group.name }}
                    </p>
                  </div>
                  <button @click="removeChannel(group.id)">
                    <ITrash class="size-4 fill-txsecondary" />
                  </button>
                </div>

                <div class="w-full h-[1px] bg-[#1B1C1E] opacity-[0.06] mb-3"></div>

                <div class="space-y-3">
                  <div
                    v-for="(item, idx) in group.items"
                    :key="`${group.id}-${item.format?.priceType}-${idx}`"
                    class="flex flex-col gap-2"
                  >
                    <div class="text-txsecondary text-sm">
                      {{ item.format?.name }}
                    </div>
                    <div class="flex justify-between items-center">
                      <p class="text-txmain text-sm font-medium">
                        {{ item.format?.price.toLocaleString() }} ₽
                      </p>
                      <div
                        class="flex items-center justify-center gap-2 relative w-[116px] h-10 bg-bgnew rounded-xl"
                      >
                        <button
                          class="absolute left-3 flex items-center justify-center"
                          @click="
                            () => {
                              if (item.quantity && item.quantity > 1) {
                                item.quantity--;
                              } else {
                                removeFormatItem(item);
                              }
                            }
                          "
                        >
                          <IMinus class="size-4 fill-primary" />
                        </button>
                        <span class="text-txmain text-sm">{{ item.quantity || 1 }}</span>
                        <button
                          class="absolute right-3 flex items-center justify-center"
                          @click="
                            () => {
                              if (item.quantity && item.quantity < 10) {
                                item.quantity++;
                              }
                            }
                          "
                        >
                          <IPlus class="size-4 fill-primary" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-scrollbar>
          <div class="flex items-center justify-between text-base mt-5">
            <div class="text-txmain text-base">Итого:</div>

            <span class="font-bold text-base">
              {{
                basket
                  .reduce(
                    (acc, place) => acc + (place.format?.price || 0) * (place.quantity || 1),
                    0
                  )
                  .toLocaleString()
              }}
              ₽
            </span>
          </div>
          <button
            class="btn-primary !w-full bg-primary text-white text-base !rounded-[18px] py-5 px-4 flex items-center justify-center mt-5"
            @click="goToOrder"
          >
            Далее
          </button>
        </template>
        <div
          v-else
          class="w-full py-20 relative bg-bgmain flex items-center justify-center mt-6 rounded-[20px]"
        >
          <img src="/public/assets/img/svg/busket_empty_2.svg" />
        </div>
      </div>
    </ElDialog>

    <el-dialog v-model="dialogDeleteLastPlace" width="450" align-center class="wrapper-dialog">
      <div class="p-8">
        <div class="flex justify-center">
          <div class="bg-bgnew rounded-2xl p-5">
            <ITrash class="size-10 fill-[#F8465B]" />
          </div>
        </div>
        <h1 class="text-txmain text-[28px] font-bold text-center mt-8">Удалить черновик?</h1>
        <p class="text-txsecondary text-base text-center mt-2">
          Удаление всех каналов приведет к удалению черновика безвозвратно
        </p>
        <div class="grid grid-cols-2 gap-3 mt-8">
          <button
            class="rounded-xl py-3.5 w-full bg-[#F8465B] text-base text-white hover:bg-[#F8465B]/90 active:bg-[#F8465B]/80"
            @click="deleteDraft"
          >
            Удалить
          </button>
          <button
            class="rounded-xl py-3.5 w-full bg-bgnew text-base text-txmain hover:bg-bgnew/90 active:bg-bgnew/80"
            @click="
              () => {
                dialogDeleteLastPlace = false;
                pendingRemovalItem = null;
              }
            "
          >
            Отмена
          </button>
        </div>
      </div>
    </el-dialog>
    </Teleport>
  </ClientOnly>
</template>

<script setup lang="ts">
  import BasketService from "@/services/BasketService";
  import type { ReducedPlace, Place, PlacePrice } from "@/interfaces/publisher";
  import ICart from "~/components/UINew/icons/ICart.vue";
  import IPlus from "~/components/UINew/icons/IPlus.vue";
  import IMinus from "~/components/UINew/icons/IMinus.vue";
  import ITrash from "~/components/UINew/icons/ITrash.vue";
  import { useBasketStore } from "~/store/BasketModule";
  import { useScreenSize } from "~/helpers/isMobile";

  import OrderService from "~/services/OrderService";
  const basketStore = useBasketStore();
  const { basket, draftId, orders } = storeToRefs(basketStore);
  const route = useRoute();
  const { isDesktop } = useScreenSize();
  const isAuth = computed(() => {
    const token = useCookie('accessTokenSJ').value;
    return !!(token && token !== '' && token !== 'undefined');
  });

  const { isBasketDialogOpen: basketDialogVisible } = storeToRefs(basketStore);
  const dialogDeleteLastPlace = ref<boolean>(false);
  const pendingRemovalItem = ref<ReducedPlace | null>(null);

  const lengthActiveOrders = computed(() => {
    return orders.value.filter((item) => item.isChecked).length;
  });

  // Группируем товары по каналам
  const groupedBasket = computed(() => {
    const groups: Array<{
      id: number;
      name: string;
      avatar: string;
      items: ReducedPlace[];
    }> = [];
    const seenChannels = new Set<number>();

    basket.value.forEach((item: ReducedPlace) => {
      if (!seenChannels.has(item.id)) {
        // Первое появление этого канала - добавляем новую группу
        groups.push({
          id: item.id,
          name: item.name,
          avatar: item.avatar,
          items: [item],
        });
        seenChannels.add(item.id);
      } else {
        // Канал уже есть - добавляем элемент в существующую группу
        const existingGroup = groups.find((group) => group.id === item.id);
        if (existingGroup) {
          existingGroup.items.push(item);
        }
      }
    });

    return groups;
  });

  const onOpenBusket = () => {
    basketDialogVisible.value = true;
    getBasket();
  };

  const goToOrder = () => {
    basketDialogVisible.value = false;
    const firstItemWithCreative: any = basket.value.find((p: any) => p.creativeId);
    navigateTo({
      path: "/order",
      query: firstItemWithCreative?.creativeId
        ? {
            e: firstItemWithCreative.creativeId,
          }
        : {},
    });
  };

  const deleteDraft = async () => {
    try {
      // Сначала удаляем элемент из корзины если он был в ожидании
      if (pendingRemovalItem.value) {
        const index = basket.value.findIndex(
          (p: ReducedPlace) =>
            p.id === pendingRemovalItem.value!.id && 
            p.format?.priceType === pendingRemovalItem.value!.format?.priceType && 
            p === pendingRemovalItem.value
        );
        if (index !== -1) {
          basket.value.splice(index, 1);
        }
        pendingRemovalItem.value = null;
      }
      
      // Затем удаляем черновик на сервере только если он существует
      if (draftId.value && draftId.value !== 0) {
        await OrderService.deleteOrder(draftId.value.toString());
      }
      
      clearBasket();
      basketStore.setDraftStatus(false);
      basketStore.setDraftId(0);
      dialogDeleteLastPlace.value = false;
    } catch (error: any) {
      ElMessage.error(error.message || "Произошла ошибка при удалении черновика");
    }
  };

  // Удаление всего канала (всех форматов)
  const removeChannel = (channelId: number) => {
    basket.value = basket.value.filter((p: ReducedPlace) => p.id !== channelId);
    if (basket.value.length === 0 && draftId.value && draftId.value !== 0) {
      dialogDeleteLastPlace.value = true;
    }
  };

  // Удаление конкретного формата
  const removeFormatItem = (item: ReducedPlace) => {
    // Проверяем, останется ли корзина пустой после удаления И есть ли черновик
    if (basket.value.length === 1 && draftId.value && draftId.value !== 0) {
      // Сохраняем элемент для удаления после подтверждения
      pendingRemovalItem.value = item;
      dialogDeleteLastPlace.value = true;
      return;
    }
    
    // Если корзина не будет пустой или нет черновика, удаляем сразу
    const index = basket.value.findIndex(
      (p: ReducedPlace) =>
        p.id === item.id && p.format?.priceType === item.format?.priceType && p === item
    );
    if (index !== -1) {
      basket.value.splice(index, 1);
    }
  };

  const removePlace = (place: Place) => {
    basket.value = basket.value.filter(
      (p: ReducedPlace) =>
        !(
          p.id === place.id &&
          (p.format?.priceType === place.format?.priceType || (!p.format && !place.format))
        )
    );
    if (basket.value.length === 0 && draftId.value && draftId.value !== 0) {
      dialogDeleteLastPlace.value = true;
    }
  };

  const clearBasket = () => {
    basket.value = [];
    // Полная очистка корзины = новый заказ → сбрасываем весь локальный черновик.
    basketStore.campaignName = "";
    if (import.meta.client) {
      localStorage.removeItem("orderId");
      localStorage.setItem("basketType", "0");
      localStorage.removeItem("multiScheduleState");
      localStorage.removeItem("orderScheduleStateV2");
      localStorage.removeItem("scheduleId");
      localStorage.removeItem("scheduleIds");
      localStorage.removeItem("campaignName");
      localStorage.removeItem("post");
      localStorage.removeItem("creativeId");
      localStorage.removeItem("creativeUuid");
      localStorage.removeItem("creativeTemporaryToken");
      localStorage.removeItem("creativeFiles");
      // Сентинел: на следующем mount шага «Пост» проигнорировать любые остатки креатива.
      localStorage.setItem("postCleared", "1");
    }
  };

  const getBasket = () => {
    const basketData = BasketService.getBasket();
    if (basketData) {
      const places = basketData.places;
      if (places) {
        places.forEach((place: any) => {
          if (!("quantity" in place)) place.quantity = 1;
          if (!("format" in place)) place.format = null;
        });
        basket.value = places;
      } else {
        basket.value = [];
      }
    }
  };

  onMounted(() => {
    getBasket();
  });
</script>

<style scoped></style>
